export const PLAYER_ACTIONS = {
    CAPTURE: 'CAPTURE',
};

export default PLAYER_ACTIONS;
